import React, { Component } from 'react';
import { Row, Col, Button, Upload, Icon, Input, Pagination, Spin, Checkbox, Table, Tooltip, Modal } from 'antd';
import { app, config } from "../../app";
import api from "../../api";
import utils from "../../utils";
import FormModal from "../../components/FormModal2";

function beforeUpload (file) {
    let format = ['image/jpeg', 'image/jpg', 'image/png'];
    const is = format.indexOf(file.type) > -1;
    if (!is) {
        app.alert('仅可上传文件类型为: ' + format.join("、"), 'warn');
        return Promise.reject();
    }
    return Promise.resolve();
}

class TETeamMien extends Component {
    constructor (props) {
        super(props);
        this.state = {
            total: 0,
            rpage: 1,
            rtotal: 0,
            page: 1,
            styleList: [],
            fileList: [],
            recordList: [],
            styleSelects: new Set(),
            fileSelects: new Set(),
            show: 0,
            is_edit: false,
            style_operation: 0,
            file_operation: 0,
        };
    }

    async componentDidMount () {
        this._isMounted = true;
        await this.handleStyleData();
    }

    componentWillUnmount () {
        this._isMounted = false;
    }

    async componentWillReceiveProps (props) {
        let { team } = this.props;
        if (team.teamno !== props.team.teamno) {
            let { styleSelects, fileSelects } = this.state;
            let state = {
                styleList: [],
                fileList: [],
                total: 0,
                page: 1,
                is_edit: false,
            };
            if (styleSelects.size > 0) {
                styleSelects.clear();
            }
            if (fileSelects.size > 0) {
                fileSelects.clear();
            }
            await this.setData(state);
            await this.handleStyleData();
        }
    }

    setData = (data) => app.setStateSync(this, data);

    /**
     * 数据处理
     * @param page
     * @returns {Promise<void>}
     */
    handleStyleData = async (page = 1) => {
        await this.setData({ page, show: 0 });
        let { team } = this.props,
            params = {
                page,
                teamno: team.teamno,
                indexno: app.getData('indexno'),
                account: app.getData('account'),
            }, { flag, data, msg, total } = await app.post(api.TeamStyleList, params);
        if (flag !== 1) {
            app.alert(msg, "error");
            data = [];
        }
        if (page === this.state.page) {
            let style_operation = 0;
            for (let i = 0; i < data.length; i++) {
                if (data[i].is_operate === 1) style_operation++;
            }
            this.state.styleSelects.clear();
            this.setData({
                style_operation,
                styleList: data,
                show: 1,
                total: parseInt(total || 0),
            });
        }
    };

    /**
     * 图片数据处理
     * @param id
     * @param is_operate
     * @returns {Promise<void>}
     */
    handleFileData = async (id, is_operate) => {
        await this.setData({ show: 0, file_id: id, is_edit: false, fileList: [] });
        let params = {
            id,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }, { flag, data, msg } = await app.post(api.TeamStyleImg, params);
        if (flag !== 1) {
            app.alert(msg, "error");
            data = [];
        }
        let state = { fileList: data.style_img, show: 2 };
        if (is_operate === 0 || is_operate === 1) {
            state.file_operation = is_operate;
        }
        this.setData(state);
    };

    /**
     * 关闭编辑框
     * @param e
     */
    handleCloseAddModal = () => {
        this.setData({ edit_visible: false });
    }

    /**
     * 打开编辑框
     * @param e
     */
    handleOpenAddModal = () => {
        this.setData({ edit_visible: true });
    }

    normFile = (e) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    }

    /**
     * 添加文件
     * @param e
     */
    handleAddStyle = async (values) => {
        await this.setData({ edit_loading: true });
        let style_img = [];
        for (let i = 0; i < values.style_img.length; i++) {
            let file = values.style_img[i];
            if (file.response && file.response.flag === 1) {
                style_img.push(file.response.data.url);
            }
        }
        let { team } = this.props, params = {
            indexno: app.getData("indexno"),
            account: app.getData("account"),
            teamno: team.teamno,
            style_title: values.style_title,
            style_img: style_img.join(":::")
        };
        let { flag, msg } = await app.post(api.TeamStyleAdd, params);
        await this.setData({ edit_loading: false });
        if (flag === 1) {
            app.alert("添加成功", "success");
            this.handleCloseAddModal();
            await this.handleStyleData();
        } else {
            app.alert(msg, "error");
        }
    };

    /**
     * 删除
     * @param show
     * @param is_edit
     */
    handleDelete = (show, is_edit) => {
        if (this.state.del_loading) return;
        if (show === 1) {
            let { styleSelects, page, total } = this.state;
            if (styleSelects.size === 0) {
                app.alert("请先选择需要删除的内容", "warn");
                return;
            }
            Modal.confirm({
                title: "确认删除选中的风采吗？",
                okText: "确认",
                cancelText: "取消",
                centered: true,
                onOk: async () => {
                    await this.setData({ del_loading: true });
                    let params = {
                        indexno: app.getData("indexno"),
                        account: app.getData("account"),
                        id: Array.from(styleSelects).join(','),
                    };
                    let { flag, msg } = await app.post(api.TeamStyleDel, params);
                    await this.setData({ del_loading: false });
                    if (flag === 1) {
                        app.alert("删除成功", "success");
                        let count = total - styleSelects.size,
                            lp = count % 20 === 0 ? parseInt(count / 20) : parseInt(count / 20) + 1;
                        if (page > lp) page = lp;
                        await this.setData({ is_edit: false });
                        await this.handleStyleData(page);
                    } else {
                        app.alert(msg, "error");
                    }
                }
            });
        } else if (show === 2) {
            if (is_edit) {
                let { fileSelects, file_id } = this.state;
                if (fileSelects.size === 0) {
                    app.alert("请先选择需要删除的内容", "warn");
                    return;
                }
                Modal.confirm({
                    title: "确认删除选中图片吗？",
                    okText: "确认",
                    cancelText: "取消",
                    centered: true,
                    onOk: async () => {
                        this.setData({ del_loading: true });
                        let params = {
                            id: file_id,
                            indexno: app.getData("indexno"),
                            account: app.getData("account"),
                            style_img: Array.from(fileSelects).join(':::'),
                        };
                        let { flag, msg } = await app.post(api.TeamStyleImgDel, params);
                        await this.setData({ del_loading: false });
                        if (flag === 1) {
                            app.alert("删除成功", "success");
                            fileSelects.clear();
                            await this.handleFileData(file_id);
                        } else {
                            app.alert(msg, "error");
                        }
                    }
                });
            } else {
                this.setData({ is_edit: true });
            }
        }
    };

    /**
     * 编辑风采
     * @param index
     * @param show
     * @param id
     * @param content
     * @returns {Promise<void>}
     */
    handleStyleEdit = async (show, id, content, index) => {
        let params = {
            id,
            content,
            type: show,
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        };
        let { flag, msg } = await app.post(api.TeamStyleSave, params);
        if (flag === 1) {
            if (show === 1) {
                app.alert("编辑成功", "success");
                this.state.styleList[index].style_title = content;
            } else {
                let { fileList } = this.state;
                fileList.push(content);
                await this.setData({ fileList });
                app.alert("添加成功", "success");
            }
        } else {
            app.alert(msg, "error");
        }
    }

    /**
     * 返回页面
     * @param show
     * @param is_edit
     */
    handleBack = (show, is_edit) => {
        let state = {};
        if (show === 1) {
            state.is_edit = !is_edit;
        } else if (show === 2) {
            let { fileSelects } = this.state;
            if (fileSelects.size > 0) {
                fileSelects.clear();
            }
            if (is_edit) {
                state.is_edit = false;
            } else {
                this.handleStyleData();
            }
        } else if (show === 3) {
            state.show = 1;
        }
        this.setData(state);
    }

    /**
     * 风采文件选择
     * @param checked
     * @param id
     */
    handleDirCheckChange = (checked, id) => {
        let { styleSelects } = this.state;
        if (checked) {
            styleSelects.add(id);
        } else {
            styleSelects.delete(id);
        }
        this.setData({ styleSelects });
    }

    /**
     * 文件选择
     * @param checked
     * @param file
     */
    handleFileCheckChange = (checked, file) => {
        let { fileSelects } = this.state;
        if (checked) {
            fileSelects.add(file);
        } else {
            fileSelects.delete(file);
        }
        console.log(fileSelects);
        this.setData({ fileSelects });
    }

    /**
     * 上传图片
     * @param file
     */
    handleImgUploadChage = ({ file }) => {
        console.log(file)
        let status = file.status;
        if (status === 'done') {
            if (file.response && file.response.flag === 1) {
                let { show, file_id } = this.state;
                this.handleStyleEdit(show, file_id, file.response.data.url);
            }
        } else if (status === 'error') {
            app.alert("上传失败", "error");
            throw "上传错误";
        }
    }

    /**
     * 操作记录数据处理
     * @param rpage
     * @returns {Promise<void>}
     */
    handleRecordData = async (rpage = 1) => {
        await this.setData({ rpage, record_loading: true });
        let { team } = this.props,
            params = {
                page: rpage,
                teamno: team.teamno,
                indexno: app.getData('indexno'),
                account: app.getData('account'),
            }, { flag, data, msg, total } = await app.post(api.TeamStyleOperateList, params);
        if (flag !== 1) {
            app.alert(msg, "error");
            data = [];
        }
        if (rpage === this.state.rpage) {
            this.setData({
                record_loading: false,
                recordList: utils.addArrayKey(data),
                rtotal: parseInt(total || 0),
            });
        }
    };

    /**
     * 跳转记录
     * @returns {Promise<void>}
     */
    handleToRecord = async () => {
        await this.setData({ show: 3 });
        await this.handleRecordData();
    }

    render () {
        let { styleList, is_edit, fileList, edit_visible, edit_loading, del_loading, total, page, rtotal, rpage, show, styleSelects,
                fileSelects, record_loading, recordList, style_operation, file_operation } = this.state,
            formItemLayout = {
                labelCol: { span: 3 },
                wrapperCol: { span: 20, offset: 1 },
            },
            columns = [
                {
                    title: '操作时间',
                    dataIndex: 'work_time',
                    key: 'work_time',
                    width: '15%'
                },
                {
                    title: '标题',
                    dataIndex: 'work_title',
                    key: 'work_title',
                    width: '20%'
                },
                {
                    title: '操作前',
                    dataIndex: 'work_before',
                    key: 'work_before',
                    width: '20%'
                },
                {
                    title: '操作后',
                    dataIndex: 'work_after',
                    key: 'work_after',
                    width: '20%'
                },
                {
                    title: '操作类型',
                    dataIndex: 'work_status',
                    key: 'work_status',
                    width: '15%',
                    render (status, { update_type }) {
                        let text = '';
                        switch (status) {
                            case '1':
                                text = '添加';
                                break;
                            case '2':
                                text = '编辑';
                                break;
                            case '3':
                                text = '删除';
                                break;
                            default:
                                text = '';
                                break;
                        }
                        return text + update_type;
                    }
                },
                {
                    title: '操作人',
                    dataIndex: 'vname',
                    key: 'vname',
                    width: '10%'
                },
            ];
        return (
            <div className="team-mien">
                <div className="head">
                    <div className="btn">
                        <Button hidden={show === 0 || (show === 1 && (styleList.length === 0 || style_operation === 0))}
                                onClick={() => this.handleBack(show, is_edit)}>{is_edit ? "完成" : (show === 1 ? "操作" : "返回")}</Button>
                        <Button style={{ margin: "0 20px" }} hidden={show !== 1 || !is_edit} loading={del_loading}
                                onClick={() => this.handleDelete(show)}>删除</Button>
                        <Button style={{ margin: "0 20px" }} hidden={show !== 2 || fileList.length === 0 || file_operation === 0}
                                loading={del_loading}
                                onClick={() => this.handleDelete(show, is_edit)}>{is_edit ? "删除" : "操作"}</Button>
                    </div>
                    <h2 className="title">队伍风采</h2>
                    <div className="btn" style={{ textAlign: "right" }} hidden={show === 3}>
                        <Button style={{ margin: "0 20px" }} hidden={show !== 1}
                                onClick={() => this.handleToRecord()}>记录</Button>
                        <Button onClick={() => this.handleOpenAddModal()} hidden={show !== 1}>添加文件</Button>
                        <Upload action={config.serverUrl + api.ImageUpload}
                                accept='image/jpeg, image/jpg, image/png'
                                data={{
                                    token: app.getData('token'),
                                    indexno: app.getData('indexno'),
                                    account: app.getData('account'),
                                    upload_type: 'team',
                                }}
                                name="image"
                                showUploadList={false}
                                onChange={this.handleImgUploadChage}
                                beforeUpload={beforeUpload}
                        >
                            <Button hidden={show !== 2 || file_operation === 0}>添加图片</Button>
                        </Upload>
                    </div>
                </div>
                <Row className="loading" type="flex" justify="center" align="middle" hidden={show !== 0}><Spin/></Row>
                <div className="tm-folder" hidden={show !== 1}>
                    <Row className="tm-dir" gutter={10}>
                        {
                            styleList.length > 0 ?
                                styleList.map((style, i) => {
                                    return (
                                        <Col span={6} key={i} className={is_edit ? "dir" : "dir dir-hover"}
                                             onClick={() => is_edit ? null : this.handleFileData(style.id, style.is_operate)}>
                                            <div className="mark" hidden={!is_edit || style.is_operate === 0}>
                                                <Checkbox checked={styleSelects.has(style.id)}
                                                          onChange={(e) => this.handleDirCheckChange(e.target.checked, style.id)}/>
                                            </div>
                                            <div className="img">
                                                <img src={config.imgUrl + style.style_img} alt=""/>
                                            </div>
                                            <div className="title">
                                                {
                                                    is_edit && style.is_operate === 1 ?
                                                        (<Tooltip trigger={['focus']} title="按回车提交" placement="topLeft">
                                                            <Input defaultValue={style.style_title} size="small"
                                                                   onPressEnter={(e) => this.handleStyleEdit(show, style.id, e.target.value, i)}
                                                                   style={{ margin: '10px 0', width: "80%" }}/>
                                                        </Tooltip>) :
                                                        (<span>{style.style_title}</span>)
                                                }
                                            </div>
                                            <div className="count">{style.total}张</div>
                                        </Col>
                                    );
                                }) :
                                (<Row className="loading" type="flex" justify="center" align="middle">暂无风采</Row>)
                        }
                    </Row>
                    <div style={{ textAlign: "right" }} hidden={styleList.length === 0}>
                        <Pagination total={total} size="small" pageSize={20} current={page}
                                    showTotal={(total) => `总数量：${total}`} onChange={this.handleStyleData}/>
                    </div>
                </div>
                <Row className="tm-file" hidden={show !== 2}>
                    {
                        fileList.length > 0 ?
                            fileList.map((file, i) => {
                                let checked = fileSelects.has(file);
                                return (
                                    <Col span={8} className="file no-select" key={i}>
                                        <img src={config.imgUrl + file} alt="图片不存在"/>
                                        <div className="mark" hidden={!is_edit}>
                                            <Icon onClick={() => this.handleFileCheckChange(!checked, file)}
                                                  type="check-square" style={{
                                                fontSize: 48,
                                                cursor: "pointer",
                                                color: checked ? "#1890ff" : "#fff"
                                            }}/>
                                        </div>
                                    </Col>);
                            }) :
                            (<Row className="loading" type="flex" justify="center" align="middle">暂无图片</Row>)
                    }
                </Row>
                <div style={{ height: 'calc(100% - 41.5px)' }} hidden={show !== 3}>
                    <Table columns={columns}
                           locale={app.tbLocale(record_loading)}
                           dataSource={recordList}
                           loading={record_loading}
                           scroll={{ y: 'calc(100% - 103px)' }}
                           style={{ height: '100%', margin: 0 }}
                           className="ranks_table"
                           pagination={false}
                           size="small"
                           footer={recordList.length === 0 ? null : () => {
                               return (
                                   <div style={{ textAlign: 'right' }}>
                                       <Pagination total={rtotal} size="small" pageSize={20} current={rpage}
                                                   showTotal={(total) => `总数量：${total}`}
                                                   onChange={this.handleRecordData}/>
                                   </div>
                               );
                           }}
                    />
                </div>
                <FormModal
                    modal={{
                        visible: edit_visible,
                        title: "添加文件",
                        onCancel: this.handleCloseAddModal,
                        okText: "确认",
                        cancelText: "取消",
                        width: 800,
                        confirmLoading: edit_loading,
                        maskClosable: false,
                        destroyOnClose: true,
                        centered: true,
                    }}
                    onSubmit={this.handleAddStyle}
                >
                    {
                        [
                            {
                                formItemLayout,
                                label: "文件标题",
                                name: "style_title",
                                options: {
                                    rules: [
                                        { required: true, message: '请输入内容' },
                                    ]
                                },
                                component: (
                                    <Input placeholder="填写标题"/>
                                )
                            },
                            {
                                formItemLayout,
                                label: "上传图片",
                                name: "style_img",
                                options: {
                                    rules: [
                                        { required: true, message: '请上传图片' },
                                    ],
                                    valuePropName: 'fileList',
                                    getValueFromEvent: this.normFile,
                                },
                                component: (
                                    <Upload
                                        action={config.serverUrl + api.ImageUpload}
                                        accept='image/jpeg, image/jpg, image/png'
                                        data={{
                                            indexno: app.getData('indexno'),
                                            account: app.getData('account'),
                                            token: app.getData('token'),
                                            upload_type: 'team',
                                        }}
                                        name="image"
                                        multiple={true}
                                        beforeUpload={beforeUpload}
                                        listType="picture"
                                        className="upload-list-inline"
                                    >
                                        <Button>
                                            <Icon type="upload"/> 点击上传
                                        </Button>
                                    </Upload>
                                )
                            }
                        ]
                    }
                </FormModal>
            </div>
        );
    }
}

export default TETeamMien;



// WEBPACK FOOTER //
// ./src/routes/ranks/TETeamMien.jsx